import { create } from "zustand";

type TCriteria = {
  id?: string;
  name?: string;
  type?: string;
};

type TCriteriaStore = {
  criteria: TCriteria;
  onSetCriteria: (criteria: TCriteria) => void;
};

export const useCriteriaStore = create<TCriteriaStore>((set) => ({
  criteria: {
    id: "",
    name: "",
    type: "",
  },
  onSetCriteria: (criteria) => {
    set({ criteria });
  },
}));
